import React from 'react';
import NavBar from '../../component/navbar/navbar';
import MarkdownListView from '../../component/markdown_listview/markdown_listview';
import FooterNav from '../../component/footernav/footernav';
import { footerNavItems, info, logo, navItems, socialMedia } from '../../../app_config';

export function QuemSomos() {

  return (
    <div className="home-container">
      <NavBar logo={logo} navitems={navItems} />

      <MarkdownListView folder="quem_somos" />

      <FooterNav logo={logo} navItems={footerNavItems} socialMedia={socialMedia} info={info} />
    </div>
  );
}

export default QuemSomos;
